// Centralized meeting utilities for consistent behavior across the platform

/**
 * Generate a unique meeting code in format: XXXX-XXXX-XXXX
 * Uses characters that are easy to read and type (no O/0, I/1 confusion)
 */
export const generateMeetingCode = (): string => {
  const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
  const segments = [];
  for (let i = 0; i < 3; i++) {
    let segment = '';
    for (let j = 0; j < 4; j++) {
      segment += chars[Math.floor(Math.random() * chars.length)];
    }
    segments.push(segment);
  }
  return segments.join('-');
};

/**
 * Generate meeting join link from code
 */
export const getMeetingLink = (meetingCode: string): string => {
  return `${window.location.origin}/join/${meetingCode}`;
};

/**
 * Format meeting code for display (add dashes if not present)
 */
export const formatMeetingCode = (code: string): string => {
  const clean = code.replace(/-/g, '').toUpperCase();
  if (clean.length !== 12) return code.toUpperCase();
  return `${clean.slice(0, 4)}-${clean.slice(4, 8)}-${clean.slice(8, 12)}`;
};

/**
 * Validate meeting code format
 * Accepts codes with 9-12 alphanumeric characters (dashes are ignored)
 * Standard format: XXXX-XXXX-XXXX (12 chars without dashes)
 */
export const isValidMeetingCode = (code: string): boolean => {
  const clean = code.replace(/-/g, '').toUpperCase();
  return /^[A-Z0-9]{9,12}$/.test(clean);
};

/**
 * Normalize meeting code for database lookup
 * Removes dashes and converts to uppercase
 */
export const normalizeMeetingCode = (code: string): string => {
  return code.replace(/-/g, '').toUpperCase();
};

/**
 * Generate a default meeting title based on time
 */
export const getDefaultMeetingTitle = (): string => {
  const hour = new Date().getHours();
  if (hour < 12) return "Morning Meeting";
  if (hour < 17) return "Afternoon Meeting";
  return "Evening Meeting";
};
